<div class="ai-chat-avatar button" role="button" id="ai-chat-avatar-toggle" [attr.aria-label]="isChatPanelOpen ? resourceStrings['Aon.AI.Avatar.CloseChat'] : resourceStrings['Aon.AI.Avatar.OpenChat']" [attr.aria-haspopup]="isChatPanelOpen ? null : 'dialog'" [class.open]="isChatPanelOpen" [class.aon-disabled]="isNiceChatWindowOpen" [attr.inert]="isNiceChatWindowOpen || null" (click)="toggleChatPanel()" (keydown.enter)="$event.target === $event.currentTarget ? $any($event.target).click() : null" (keydown.space)="$event.target === $event.currentTarget ? $event.preventDefault() : null" (keyup.space)="$event.target === $event.currentTarget ? $any($event.target).click() : null" tabindex="0">
  <i class="fal fa-atom icon" 
     [class.hidden]="isChatPanelOpen" aria-hidden="true"></i>
  <i class="fal fa-times icon" 
     [class.hidden]="!isChatPanelOpen" aria-hidden="true"></i>
</div>
@if (isMobile && !isChatPanelOpen) {
  <span (click)="toggleChatPanel()"
        (keydown.enter)="toggleChatPanel()"
        (keydown.space)="toggleChatPanel(); $event.preventDefault()"
        role="button"
        tabindex="0"
        [attr.aria-label]="resourceStrings['Aon.AI.Avatar.AonAiChat']"
        class="ai-text">
    {{resourceStrings['Aon.AI.Avatar.AonAiChat']}}
  </span>
}
